import { render, staticRenderFns } from "./card-gif.vue?vue&type=template&id=828ece72&scoped=true"
import script from "./card-gif.vue?vue&type=script&lang=js"
export * from "./card-gif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828ece72",
  null
  
)

export default component.exports